module.exports = __webpack_public_path__ + "img/a-dead-djinn-in-cairo.fbf81b45.png";